<script setup lang="ts">

import {PropType, Ref, ref, watch} from "vue";
import {CustomDTOExpression, OperatorOption} from "@/utils/presenters/interfaces.ts";
import DropDownFieldWidgetUtil from "@/utils/editView/widgets/DropDownFieldWidgetUtil.ts";
import {QSelect} from "quasar";

const model = defineModel({
  type: Object as PropType<CustomDTOExpression>
});
const emit = defineEmits(["afterUpdateCriteriaOperator"]);
const props = defineProps({
  operators: {
    type: Array<OperatorOption>,
    required: true
  }
});
const selectedOperator: Ref<OperatorOption | null | undefined> = ref(fetchSelectedOperator());
const inputValue = ref<string | null | undefined>(selectedOperator.value?.label);
const operatorsOptions = ref(props.operators);

function fetchSelectedOperator() {
  const operator = model.value!.operator;
  let value: OperatorOption | undefined = undefined;
  if (operator)
    value = props.operators.find(l => l.value === operator);
  return value;
}

watch(() => model.value!.operator, () => {
  selectedOperator.value = fetchSelectedOperator();
});

function onSelect(newValue: OperatorOption) {
  selectedOperator.value = newValue;
  model.value!.operator = newValue ? newValue.value : undefined;
  emit('afterUpdateCriteriaOperator');
}

function dropDrownFilter(val: any, update: any) {
  update(() => filter(val),
    ref => {
      if (val !== '' && ref.options.length > 0) {
        ref.setOptionIndex(-1);
        ref.moveOptionSelection(1, true);
      }
    })
}

function filter(value: string | null | undefined) {
  if (!value) {
    operatorsOptions.value = props.operators;
    return;
  }
  operatorsOptions.value = props.operators.filter(e => DropDownFieldWidgetUtil.isAllowedValueMatched(e, value))
    .sort((a, b) => a.value === b.value ? 0 : a.searchValue!.length - b.searchValue!.length);
}

function onPartialUserInput(val) {
  if (!val) {
    selectedOperator.value = null;
    model.value!.operator = undefined;
    emit('afterUpdateCriteriaOperator');
  }
  inputValue.value = val;
}

function onUserInputFinished() {
  if (inputValue.value) {
    const matched: OperatorOption | undefined = props.operators.find(e => DropDownFieldWidgetUtil.isAllowedValueMatched(e, inputValue.value));
    if (matched) {
      if (selectedOperator.value && selectedOperator.value!.value === matched.value)
        return;
      selectedOperator.value = matched;
      inputValue.value = matched.label;
      model.value!.operator = matched.value;
      emit('afterUpdateCriteriaOperator');
    } else {
      if (!selectedOperator.value)
        return;
      selectedOperator.value = null;
      model.value!.operator = undefined;
      emit('afterUpdateCriteriaOperator');
    }
  } else {
    selectedOperator.value = null;
    model.value!.operator = undefined;
    emit('afterUpdateCriteriaOperator');
  }
}
</script>

<template>
  <q-select dense options-dense outlined use-input hide-selected fill-input
            :model-value="selectedOperator"
            :options="operatorsOptions as OperatorOption[]"
            @update:model-value="onSelect"
            @filter="dropDrownFilter"
            @input-value="onPartialUserInput"
            @blur="onUserInputFinished"
            option-label="label"
            option-value="id"
            input-debounce="0"
            class="nama-field-input nama-customize-dense-input"
            input-class="tw-text-base tw-font-normal dark:tw-text-namaFontColor-input-dark tw-bg-transparent focus:tw-ring-0"
            options-selected-class="tw-pl-[6px] tw-pr-[3px] tw-text-base tw-font-normal tw-border-b-black tw-bg-primary-light dark:tw-bg-primary-dark tw-text-namaFontColor-input-dark"
            popup-content-class="!tw-max-h-[30vh] tw-text-base tw-font-normal dark:tw-text-namaFontColor-input-dark dark:tw-bg-namaBackground-bright-dark"/>
</template>

<style scoped>

</style>
